var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 120,
    viewBox: "0 0 162 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 120,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 103.182L43.6061 73.9486V25H142.394V73.9486L153 103.227H117.905C117.073 103.227 116.398 103.902 116.398 104.734V104.734C116.398 105.566 117.073 106.241 117.905 106.241H153V111H33V103.182ZM137.474 29.8864L47.8483 29.6739V72.767H137.688L137.474 29.8864Z",
    fill: "#777081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36C73 38.2091 71.2091 40 69 40C66.7909 40 65 38.2091 65 36C65 33.7909 66.7909 32 69 32C71.2091 32 73 33.7909 73 36Z",
    fill: "#777081"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 58C73 60.2091 71.2091 62 69 62C66.7909 62 65 60.2091 65 58C65 55.7909 66.7909 54 69 54C71.2091 54 73 55.7909 73 58Z",
    fill: "#777081"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119 58C119 60.2091 117.209 62 115 62C112.791 62 111 60.2091 111 58C111 55.7909 112.791 54 115 54C117.209 54 119 55.7909 119 58Z",
    fill: "#777081"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47.5C63 43.9101 65.6863 41 69 41C72.3137 41 75 43.9101 75 47.5V47.5C75 48.3284 74.3284 49 73.5 49H64.5C63.6716 49 63 48.3284 63 47.5V47.5Z",
    fill: "#777081"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69.5C63 65.9101 65.6863 63 69 63C72.3137 63 75 65.9101 75 69.5V69.5C75 70.3284 74.3284 71 73.5 71H64.5C63.6716 71 63 70.3284 63 69.5V69.5Z",
    fill: "#777081"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109 69.5C109 65.9101 111.686 63 115 63C118.314 63 121 65.9101 121 69.5V69.5C121 70.3284 120.328 71 119.5 71H110.5C109.672 71 109 70.3284 109 69.5V69.5Z",
    fill: "#777081"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 97C81 94.7909 82.7909 93 85 93H101C103.209 93 105 94.7909 105 97V97C105 99.2091 103.209 101 101 101H85C82.7909 101 81 99.2091 81 97V97Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67 86.5C67 85.6716 67.6716 85 68.5 85H118.5C119.328 85 120 85.6716 120 86.5V86.5C120 87.3284 119.328 88 118.5 88H68.5C67.6716 88 67 87.3284 67 86.5V86.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59 79.5C59 78.6716 59.6716 78 60.5 78H126.5C127.328 78 128 78.6716 128 79.5V79.5C128 80.3284 127.328 81 126.5 81H60.5C59.6716 81 59 80.3284 59 79.5V79.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51H138V52H47V51Z",
    fill: "#777081"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92 73L92 29L93 29L93 73L92 73Z",
    fill: "#777081"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.836 36.9706L97 48H115V33L110.726 40.6167L107.576 35.2847L104.032 40.6167L100.836 36.9706Z",
    fill: "#777081"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.207 41.4377C120.207 45.0622 123.145 48.0004 126.77 48.0004C130.394 48.0004 133.332 45.0622 133.332 41.4377C133.332 37.8132 130.394 34.875 126.77 34.875V41.4377H120.207Z",
    fill: "#777081"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.895 33C121.27 33 118.332 35.9382 118.332 39.5627H124.895V33Z",
    fill: "#777081"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56C56 65.3888 48.3888 73 39 73C29.6112 73 22 65.3888 22 56C22 46.6112 29.6112 39 39 39C48.3888 39 56 46.6112 56 56Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.875 70.8824C47.0829 70.8824 53.75 64.2003 53.75 55.9412C53.75 47.682 47.0829 41 38.875 41C30.6671 41 24 47.682 24 55.9412C24 64.2003 30.6671 70.8824 38.875 70.8824ZM38.875 72.8824C48.1948 72.8824 55.75 65.2975 55.75 55.9412C55.75 46.5848 48.1948 39 38.875 39C29.5552 39 22 46.5848 22 55.9412C22 65.2975 29.5552 72.8824 38.875 72.8824Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17 99.8866C17 87.3117 27.0736 77.1177 39.5 77.1177C51.9264 77.1177 62 87.3117 62 99.8866V107C62 109.209 60.2091 111 58 111H21C18.7909 111 17 109.209 17 107V99.8866Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17 116.562C17 114.906 18.3431 113.562 20 113.562H59C60.6569 113.562 62 114.906 62 116.562V116.562C62 118.219 60.6569 119.562 59 119.562H20C18.3431 119.562 17 118.219 17 116.562V116.562Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 105.562L35 100.926L36.5 88.5625L42.5 88.5625L44 100.926L39.5 105.562Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 85.5625C38.1193 85.5625 37 84.4432 37 83.0625V83.0625C37 81.6818 38.1193 80.5625 39.5 80.5625V80.5625C40.8807 80.5625 42 81.6818 42 83.0625V83.0625C42 84.4432 40.8807 85.5625 39.5 85.5625V85.5625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/work-icon.a2e3a7e1.svg";
export { ForwardRef as ReactComponent };